import { OptionType } from '@/components/inputs/types';

export const USStates: OptionType[] = [
  { label: 'Alabama', value: 'ICAC - Alabama' },
  { label: 'Alaska', value: 'ICAC - Alaska' },
  { label: 'Arizona', value: 'ICAC - Arizona' },
  { label: 'Arkansas', value: 'ICAC - Arkansas' },
  { label: 'California', value: 'ICAC - California' },
  { label: 'Colorado', value: 'ICAC - Colorado' },
  { label: 'Connecticut', value: 'ICAC - Connecticut' },
  { label: 'Delaware', value: 'ICAC - Delaware' },
  { label: 'Florida', value: 'ICAC - Florida' },
  { label: 'Georgia', value: 'ICAC - Georgia' },
  { label: 'Hawaii', value: 'ICAC - Hawaii' },
  { label: 'Idaho', value: 'ICAC - Idaho' },
  { label: 'Illinois', value: 'ICAC - Illinois' },
  { label: 'Indiana', value: 'ICAC - Indiana' },
  { label: 'Iowa', value: 'ICAC - Iowa' },
  { label: 'Kansas', value: 'ICAC - Kansas' },
  { label: 'Kentucky', value: 'ICAC - Kentucky' },
  { label: 'Louisiana', value: 'ICAC - Louisiana' },
  { label: 'Maine', value: 'ICAC - Maine' },
  { label: 'Maryland', value: 'ICAC - Maryland' },
  { label: 'Massachusetts', value: 'ICAC - Massachusetts' },
  { label: 'Michigan', value: 'ICAC - Michigan' },
  { label: 'Minnesota', value: 'ICAC - Minnesota' },
  { label: 'Mississippi', value: 'ICAC - Mississippi' },
  { label: 'Missouri', value: 'ICAC - Missouri' },
  { label: 'Montana', value: 'ICAC - Montana' },
  { label: 'Nebraska', value: 'ICAC - Nebraska' },
  { label: 'Nevada', value: 'ICAC - Nevada' },
  { label: 'New Hampshire', value: 'ICAC - New Hampshire' },
  { label: 'New Jersey', value: 'ICAC - New Jersey' },
  { label: 'New Mexico', value: 'ICAC - New Mexico' },
  { label: 'New York', value: 'ICAC - New York' },
  { label: 'North Carolina', value: 'ICAC - North Carolina' },
  { label: 'North Dakota', value: 'ICAC - North Dakota' },
  { label: 'Ohio', value: 'ICAC - Ohio' },
  { label: 'Oklahoma', value: 'ICAC - Oklahoma' },
  { label: 'Oregon', value: 'ICAC - Oregon' },
  { label: 'Pennsylvania', value: 'ICAC - Pennsylvania' },
  { label: 'Rhode Island', value: 'ICAC - Rhode Island' },
  { label: 'South Carolina', value: 'ICAC - South Carolina' },
  { label: 'South Dakota', value: 'ICAC - South Dakota' },
  { label: 'Tennessee', value: 'ICAC - Tennessee' },
  { label: 'Texas', value: 'ICAC - Texas' },
  { label: 'Utah', value: 'ICAC - Utah' },
  { label: 'Vermont', value: 'ICAC - Vermont' },
  { label: 'Virginia', value: 'ICAC - Virginia' },
  { label: 'Washington', value: 'ICAC - Washington' },
  { label: 'West Virginia', value: 'ICAC - West Virginia' },
  { label: 'Wisconsin', value: 'ICAC - Wisconsin' },
  { label: 'Wyoming', value: 'ICAC - Wyoming' }
];
